import { saveAs } from 'file-saver';
import { getFileExtension } from './stringHelper';

// import XLS from 'assets/images/icons/xls.svg';
// import DOC from 'assets/images/icons/doc.svg';
// import PNG from 'assets/images/icons/png.svg';
// import JPG from 'assets/images/icons/jpg.svg';
// import PDF from 'assets/images/icons/pdf.svg';
// import FILE from 'assets/images/file/File.svg';

import { getBase64 } from './common';

export const LIMIT_VIDEO_SIZE_MB = 100;
export const LIMIT_IMAGE_SIZE_KB = 110;

export const ACCEPT_IMAGE = 'image/png, image/jpeg';

export const bytesToMB = (bytes) => {
  return bytes / Math.pow(1024, 2);
};

export const bytesToKB = (bytes) => {
  return bytes / Math.pow(1024, 1);
};

export const downloadCsvBase64 = async (str, name) => {
  const blob = await fetch(`data:text/csv;base64,${str}`).then((res) =>
    res.blob()
  );
  const url = URL.createObjectURL(blob);
  saveAs(url, `${name}.csv`);
};

export const downloadFileFromUrl = saveAs;

// export const getFileFormatImage = (extension) => {
//   let iconType = FILE;
//   switch (extension.toLowerCase()) {
//     case 'jpeg':
//     case 'jpg':
//       iconType = JPG;
//       break;
//     case 'png':
//       iconType = PNG;
//       break;
//     case 'csv':
//     case 'xls':
//     case 'xlsx':
//       iconType = XLS;
//       break;
//     case 'doc':
//     case 'docx':
//       iconType = DOC;
//       break;
//     case 'pdf':
//       iconType = PDF;
//       break;
//     default:
//       iconType = FILE;
//   }
//   return iconType;
// };

export const getImageFromFileName = (fileName) => {
  const extension = getFileExtension(fileName);
  return getFileFormatImage(extension);
};

export const getImageFromFile = async (file, showImage = true) => {
  const { name, type, preview, isImage } = file;
  if (showImage) {
    if (preview && isImage) {
      return preview;
    }
    if (type && type.indexOf('image') > -1) {
      const image = await getBase64(file);
      return image;
    }
  }
  let extension = file.extension || getFileExtension(name);
  extension = extension.replace('.', '');
  return getFileFormatImage(extension);
};

export const getImageDimensionsFromFile = (file) => {
  return new Promise((resolve, reject) => {
    let img = new Image();
    img.onload = function () {
      file.dimensions = [this.width, this.height].join('x');
      file.width = this.width;
      file.height = this.height;
      resolve(file);
    };
    img.onerror = function (err) {
      reject(err);
    };
    img.src = URL.createObjectURL(file);
  });
};

export const calculateGCD = (width, height) => {
  if (height === 0) return width;
  return calculateGCD(height, width % height);
};

export const getVideoMetadataFromFile = (file) => {
  return new Promise((resolve, reject) => {
    let video = document.createElement('video');
    video.preload = 'metadata';

    video.onloadedmetadata = function () {
      URL.revokeObjectURL(video.src);

      const ratio = calculateGCD(video.videoWidth, video.videoHeight);
      const videoInfo = {
        duration: Math.floor(video.duration),
        ratio: `${video.videoWidth / ratio}:${video.videoHeight / ratio}`,
      };
      resolve(videoInfo);
    };

    video.onerror = function (err) {
      reject(err);
    };

    video.src = URL.createObjectURL(file);
  });
};

export const bytesToSize = (bytes) => {
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return 'n/a';
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
  if (i === 0) return `${bytes} ${sizes[i]}`;
  return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`;
};

// function removeFile({ payload, callbackSuccess }) {
//   try {
//     yield call(() => axios.delete(`${API.FILE}?slug=${payload}`));
//     callbackSuccess();
//   } catch (err) {
//     const errData = ErrorHandler.getErrorData(err);
//     showModalError({ content: errData.message });
//   }
// }

// function uploadFile({ payload, config, callbackSuccess, folder = '' }) {
//   try {
//     const { name } = payload;
//     const fileBase64 = yield call(() => getBase64(payload));
//     const data = {
//       name,
//       contentBase64: fileBase64,
//       folder,
//       isEnableCompressImage: true,
//       imageMaxWidthPx: 0,
//       imageMaxHeightPx: 0,
//     };
//     const res = yield call(() => axios.post(API.FILE, data, config || {}));
//     callbackSuccess(res.data);
//   } catch (err) {
//     const errData = ErrorHandler.getErrorData(err);
//     showModalError({ content: errData.message });
//   }
// }

// function uploadMultipleFile({
//   payload,
//   config = {},
//   callbackSuccess,
//   folder = '',
// }) {
//   try {
//     const res = yield all(
//       payload.map(({ originFileObj }) => {
//         return call(async () => {
//           const fileBase64 = await getBase64(originFileObj);
//           const data = {
//             name: originFileObj.name,
//             contentBase64: fileBase64,
//             folder,
//             isEnableCompressImage: true,
//             imageMaxWidthPx: 0,
//             imageMaxHeightPx: 0,
//           };
//           return axios.post(API.FILE, data, config);
//         });
//       })
//     );
//     callbackSuccess(Array.isArray(res) ? res.map((r) => r.data) : []);
//   } catch (err) {
//     const errData = ErrorHandler.getErrorData(err);
//     showModalError({ content: errData.message });
//   }
// }

// function downloadFile({ payload }) {
//   try {
//     const { uri, name } = payload;
//     const res = yield call(() =>
//       axios.get(`${API.FILE}/download?RemoteUri=${uri}&FileName${name}`)
//     );
//   } catch (err) {
//     const errData = ErrorHandler.getErrorData(err);
//     showModalError({ content: errData.message });
//   }
// }

// function removeBulkFile({ payload, callbackSuccess }) {
//   try {
//     yield call(() => axios.post(`${API.FILE}/bulk`, payload));
//     callbackSuccess();
//   } catch (err) {
//     const errData = ErrorHandler.getErrorData(err);
//     showModalError({ content: errData.message });
//   }
// }
